import AnnouncementCustomService from "../../../../services/abstract/announcements/AnnouncementCustomService";
import AnnouncementCustomServiceApi from "../../../../services/api/announcements/AnnouncementCustomServiceApi";
import AnnouncementsPallets from "../../../../components/announcement/pallets/AnnouncementsPallets";
import { OK } from "http-status-codes";
import React from "react";

interface Props {}
interface State {
  announcements: Array<App.Announcement.Announcement>;
}

class CheckedAnnouncementsList extends React.Component<Props, State> {
  private service: AnnouncementCustomService;
  constructor(props: Props) {
    super(props);
    this.service = new AnnouncementCustomServiceApi();
    this.state = {
      announcements: [],
    };
  }

  public componentDidMount() {
    this.loadAnnouncements();
  }
  public async loadAnnouncements() {
    const { data, status } = await this.service.getChecked();
    if (status === OK) {
      this.setState({ announcements: data });
    }
  }
  public render() {
    return (
      <AnnouncementsPallets
        className="checked-announcements"
        title={"Проверенные объявления"}
        announcements={this.state.announcements}
      />
    );
  }
}

export default CheckedAnnouncementsList;
